import { NavigateWithParams } from '@spacefill/shared/src/utils/RouterUtils';

const CustomerView = async () =>
    import('../../pages/customers/View').then((module) => ({
        Component: module.CustomerView,
    }));
const CustomersList = async () =>
    import('../../pages/customers/List').then((module) => ({
        Component: module.CustomersList,
    }));
const CustomerWarehouseConfigurationsEdit = async () =>
    import('../../pages/customers/customer-warehouse-configurations/Edit').then((module) => ({
        Component: module.CustomerWarehouseConfigurationsEdit,
    }));
const CustomerWarehouseConfigurationsView = async () =>
    import('../../pages/customers/customer-warehouse-configurations/View').then((module) => ({
        Component: module.CustomerWarehouseConfigurationsView,
    }));

const CustomerCarrierView = async () =>
    import('../../pages/customers/carriers/Edit').then((module) => ({
        Component: module.CustomerCarrierEdit,
    }));

const getCustomerRouter = (_user, _features) => [
    {
        path: '/customers/',
        lazy: CustomersList,
    },
    {
        path: '/customers/:customerId/',
        lazy: CustomerView,
    },

    // Users
    {
        path: '/customers/:customerId/users/',
        lazy: CustomerView,
    },

    // Customer warehouse configurations
    {
        path: '/customers/:customerId/warehouse-configurations/',
        lazy: CustomerView,
    },
    {
        path: '/customers/:customerId/warehouse-configurations/:customerWarehouseConfigurationId/edit',
        lazy: CustomerWarehouseConfigurationsEdit,
    },
    {
        path: '/customers/:customerId/warehouse-configurations/:customerWarehouseConfigurationId/',
        lazy: CustomerWarehouseConfigurationsView,
    },

    // Logistic Management
    {
        path: '/customers/:customerId/logistic-management/inventory/items/',
        lazy: CustomerView,
    },
    {
        path: '/customers/:customerId/settings/',
        lazy: CustomerView,
    },
    {
        path: '/customers/:customerId/settings/edit',

        element: <NavigateWithParams to={(params) => `/customers/${params.customerId}/settings/`} />,
    },
    {
        path: '/customers/:customerId/carriers/',
        lazy: CustomerView,
    },
    {
        path: '/customers/:customerId/customer-channels/',
        lazy: CustomerView,
    },
    {
        path: '/customers/:customerId/carriers/:customerCarrierId',
        lazy: CustomerCarrierView,
    },
    {
        path: '/customers/:customerId/permissions/',
        lazy: CustomerView,
    },
];

export { getCustomerRouter };
